/**
 * Safe internal redirect path from ?next= query param.
 */
export function safeLoginNextPath(raw: string | null | undefined): string {
  if (!raw) return '/'
  if (!raw.startsWith('/') || raw.startsWith('//')) return '/'
  return raw
}
